// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { browserHistory as history } from 'react-router';
import { connect } from 'react-redux';
import { loadSites } from '../../actions/actions';
// import { getValuesFromParseClass } from '../../actions/Api';
import Article from 'grommet/components/Article';
import Section from 'grommet/components/Section';
import Title from 'grommet/components/Title';
import Layer from 'grommet/components/Layer';
import Header from 'grommet/components/Header';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Button from 'grommet/components/Button';
import CaretBack from 'grommet/components/icons/base/CaretBack';
import CaretNext from 'grommet/components/icons/base/CaretNext';

import constants from '../../Constants';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';

import NavControl from '../NavControl';
import EditAlert from './EditAlert';


import { navEnable } from '../../actions/nav';
import { getAlertsApi, addAlertAction, updateAlertAction, deleteAlertAction } from '../../actions/locationView';

var siteName = '';
var disableAll = false;
var selectedAlert = false;
class Alerts extends Component {

  constructor(props) {
    super(props);
      // console.log('ppp', this.props);
    this.showPopup = this.showPopup.bind(this);
    this.addAlertBtnClick = this.addAlertBtnClick.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.addAlert = this.addAlert.bind(this);
    this.deleteAlert = this.deleteAlert.bind(this);
    this.selectAlert = this.selectAlert.bind(this);
    // this.closeEditPop = this.closeEditPop.bind(this);
    // this.saveTwig = this.saveTwig.bind(this);
    // this.loadPrevRecomnd = this.loadPrevRecomnd.bind(this);
    // this.loadNextRecomnd = this.loadNextRecomnd.bind(this);
    // this.gotToLocation = this.gotToLocation.bind(this);
    // this.getLastUpdateValue = this.getLastUpdateValue.bind(this);
    // this.gotoAlerts = this.gotoAlerts.bind(this);
    this.state = {
      alertItem: '',
      showPopup: false,
      addMode: false
    }


  }
  componentWillMount() {
    this.props.dispatch(navEnable(true));
    this.props.dispatch(getAlertsApi(this.props.selectedTwig.twigId));
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {
    siteName = '';
  }

  gotoAlerts() {
    history.push({
      pathname: constants.ROUTES.ALERTS
    })
  }

  showPopup(alert, alertDetails) {
      // console.log(ReactDOM.findDOMNode(this.refs.alertPage))
    let parentElement = ReactDOM.findDOMNode(this.refs.alertPage).parentElement;
    parentElement.scrollTop = 0;
    parentElement.style.overflow = 'hidden';
    
    this.setState({
      showPopup: true,
      addMode: false,
      alertItem: { alertDetails: alertDetails, alert: alert }
    })
  }

  addAlertBtnClick() {
    // let parentElement = ReactDOM.findDOMNode(this.refs.alertPage).parentElement;
    // parentElement.scrollTop = 0;
    // parentElement.style.overflow = 'hidden';
    this.setState({
      showPopup: true,
      addMode: true,
    })
  }

  addAlert(alertData, alertId) {
    if (this.state.addMode) {
      alertData['twigId'] = this.props.selectedTwig.twigId;
        // console.log('alertData::', alertData)
      this.props.dispatch(addAlertAction(alertData, this.props.selectedTwig.twigId));
    } else {
      this.props.dispatch(updateAlertAction(alertId, alertData, this.props.selectedTwig.twigId));
    }
    this.closePopup();
  }
  selectAlert(index) {
    selectedAlert = this.props.alerts[index];

  }
  deleteAlert() {
    if (selectedAlert) {
      this.props.dispatch(deleteAlertAction(selectedAlert.id, this.props.selectedTwig.twigId));
    } else {
      alert('Please select an Alert to delete.')
    }
    selectedAlert = false;
  }
  closePopup() {
    let parentElement = ReactDOM.findDOMNode(this.refs.alertPage).parentElement;
    parentElement.style.scrollTop = 0;
    parentElement.style.overflow = 'auto';
    this.setState({
      showPopup: false,
      alertItem: {}
    })
  }


  render() {
      // console.log('alerts::', this.props.alerts)

    return (
      <Article className='maxheight alerts-page' ref='alertPage'>

        <Header size='large' pad={{ between: 'small', horizontal: 'small' }}>
          <Title>
            Alerts
          </Title>
          <Button label='Add Alert'
            className='lighter-font'
            onClick={this.addAlertBtnClick}
            primary={true}
            secondary={false}
            accent={false} />
          <Button label='Delete Alert'
            className='lighter-font'
            onClick={this.deleteAlert}
            primary={true}
            secondary={false}
            accent={false} />
        </Header>
        <List selectable={true}
          onSelect={this.selectAlert}
        >
          {
            this.props.alerts.map((alert, index) => {
              return <AlertListItem alert={alert} key={index} selectedTwig={this.props.selectedTwig} showPopup={this.showPopup} addAlert={this.addAlert} />
            })
          }
        </List>
        {this.state.showPopup ? <EditAlert show={this.state.showPopup} addMode={this.state.addMode} alertItem={this.state.alertItem} selectedTwig={this.props.selectedTwig} closePopup={this.closePopup} addAlert={this.addAlert} /> : null}
      </Article>
    );
  }

}



let select = (state, props) => ({
  selectedTwig: state.locationView.selectedTwig,
  alerts: state.locationView.alerts
});

export default connect(select)(Alerts);


class AlertListItem extends Component {
  constructor(props) {
    super(props);
    this.updateState = this.updateState.bind(this);
    this.updateAlert = this.updateAlert.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.state = {
      name: this.props.alert.name.toUpperCase(),
      description: this.props.alert.description,
      isEnabled: this.props.alert.isEnabled,
      detailLabel: '',
      conditionLabel: '',
      condition: '',
      value: '',
      unit: '',
      alertType: '',
      alertTypeLabel: '',
      detailKey: ''
    }

  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      name: nextProps.alert.name.toUpperCase(),
      description: nextProps.alert.description,
      isEnabled: nextProps.alert.isEnabled,
    });
    this.updateState();
  }
  componentWillMount() {
    this.updateState();
  }
  updateState() {
    let detailKey = '';
    let alertType = '';
    let triggers = _.cloneDeep(this.props.alert.triggers);
    delete triggers['leaf_id'];
    for (let key in triggers) {
      detailKey = key;
      break;
    }
    for (let key in this.props.alert.actions) {
      alertType = key;
      break;
    }
    let isGreaterThan = triggers[detailKey]['gt'] != null ? true : false;
    let isLowerThan = triggers[detailKey]['lt'] != null ? true : false;
    let value, conditionLabel, condition, detailLabel = '', unit = '';
    if (isGreaterThan) {
      conditionLabel = 'Exceeds';
      value = triggers[detailKey]['gt'];
      condition = 'gt';
    }
    if (isLowerThan) {
      conditionLabel = 'Falls below'
      value = triggers[detailKey]['lt'];
      condition = 'lt';
    }
    if (this.props.selectedTwig.details.data[detailKey] &&
      this.props.selectedTwig.details.data[detailKey].label &&
      this.props.selectedTwig.details.data[detailKey].Unit) {
      detailLabel = this.props.selectedTwig.details.data[detailKey].label;
      unit = '(' + this.props.selectedTwig.details.data[detailKey].Unit + ')';
    }
    this.setState({
      detailLabel: detailLabel,
      conditionLabel: conditionLabel,
      condition: condition,
      value: value,
      unit: unit,
      alertType: alertType,
      alertTypeLabel: alertType.toUpperCase(),
      detailKey: detailKey
    });
  }

  updateAlert() {
    let alertDetails = {
      condition: this.state.condition,
      detailsKey: this.state.detailKey,
      alertType: this.state.alertType
    }
    this.props.showPopup(this.props.alert, alertDetails);
  }

  toggleAlert(event) {
    let alertData = {
      isEnabled: !this.state.isEnabled
    }
    this.props.addAlert(alertData, this.props.alert.id)
  }


  render() {
      // console.log('this.state::', this.state)
    let listClass = this.state.isEnabled ? 'list-item' : 'list-item disabled';

    let enableDisableButton;
    if (this.state.isEnabled) {
      enableDisableButton = <Button label='Disable'
        className='lighter-font float-right mr-10'
        onClick={this.toggleAlert}
        primary={false}
        accent={true}
      />
    } else {
      enableDisableButton = <Button label='Enable'
        className='lighter-font float-right mr-10'
        onClick={this.toggleAlert}
        primary={false} />
    }

    return (
      <ListItem className={listClass} >
        <div>
          <span>{this.state.name}</span>
          <Button label='Update'
            className='lighter-font float-right mr-10'
            onClick={this.updateAlert}
            primary={true}
            secondary={false}
            accent={false} />
          {enableDisableButton}
        </div>
        <div>
          {this.state.description}
        </div>
        <div>
          <span className='secondary'>
            {this.state.detailLabel}
          </span>
          <span className='secondary ml-3'>
            {this.state.conditionLabel + ' ' + this.state.value + ' ' + this.state.unit}
          </span>
          <span className='secondary ml-3'>
            {this.state.alertTypeLabel}
          </span>
        </div>
      </ListItem >
    )
  }
}




// WEBPACK FOOTER //
// ./src/js/components/site/Alerts.js